import {undef} from './';

function allowFieldAutoProgress(formOptions, fieldOptions) {
    const {
        autoProgress: formAutoProgress
    } = formOptions;

    const {
        autoProgress: fieldAutoProgress
    } = fieldOptions;

    return (
        fieldAutoProgress ||
        formAutoProgress && fieldAutoProgress === undef
    );
}

function allowFieldAutoSubmit(formOptions, fieldOptions) {
    const {
        autoSubmit: formAutoSubmit
    } = formOptions;

    const {
        autoSubmit: fieldAutoSubmit
    } = fieldOptions;

    return (
        fieldAutoSubmit ||
        formAutoSubmit && fieldAutoSubmit === undef
    );
}

function allowInputFieldErrorHighlighting(formOptions, fieldOptions) {
    const {
        allowErrorHighlighting: allowFormErrorHighlighting
    } = formOptions;

    const {
        allowErrorHighlighting: allowFieldErrorHighlighting
    } = fieldOptions;

    return (
        allowFieldErrorHighlighting ||
        allowFormErrorHighlighting && allowFieldErrorHighlighting === undef
    );
}

export {
    allowFieldAutoProgress,
    allowFieldAutoSubmit,
    allowInputFieldErrorHighlighting
};
